import React, { createContext, useState } from 'react';
import { getLocale } from '../../store/cache/locales';
import { availableLocales, defaultLocale } from './Intl';
export var LocaleContext = createContext({
    locale: defaultLocale,
    setLocale: function (f) { return f; },
});
export var LocaleContextProvider = function (_a) {
    var children = _a.children;
    // Check if locale is present in the localStorage
    var selectedLocale = getLocale();
    if (!availableLocales.includes(selectedLocale)) {
        // Here we validate that the locale is supported since getLocale()
        // falls back on the browser locale if none was previously stored.
        selectedLocale = defaultLocale;
    }
    var _b = useState(selectedLocale), locale = _b[0], setLocale = _b[1];
    var localeContext = {
        locale: locale,
        setLocale: setLocale,
    };
    return React.createElement(LocaleContext.Provider, { value: localeContext }, children);
};
